import { moduleTypes } from '../moduleTypes';

const experimentalModules = [];

export const companyInstrumentModules = [
  { value: moduleTypes.CREDIT_RATING, label: 'Credit Rating' },
  { value: moduleTypes.RATING_NEWS, label: 'Rating News' },
  { value: moduleTypes.RESEARCH, label: 'Research' },
  { value: moduleTypes.DOCUMENTS, label: 'Documents' },
];

export const companyEntityModules = [
  { value: moduleTypes.SUMMARY_CARD, label: 'Summary Card', spv: true },
  { value: moduleTypes.CREDIT_RATING, label: 'Credit Rating', module: 'credit' },
  { value: moduleTypes.CREDIT_REVIEW, label: 'Credit Review' },
  { value: moduleTypes.ESG_IMPACT, label: 'ESG Impact', module: 'esg' },
  { value: moduleTypes.ESG_SENTIMENT, label: 'ESG Sentiment', module: 'esg', disabled: true },
  { value: moduleTypes.CLIMATE_STRESS_TEST, label: 'Climate Stress Test', module: 'esg' },
  { value: moduleTypes.INSTRUMENTS, label: 'Instruments', spv: true, module: 'credit' },
  { value: moduleTypes.RATING_NEWS, label: 'Rating News', spv: true, module: 'credit' },
  { value: moduleTypes.RESEARCH, label: 'Research', spv: true, module: 'credit' },
  { value: moduleTypes.DOCUMENTS, label: 'Documents', spv: true, module: 'credit' },
];

export const getCurrentEnvironmentModules = (areExperimentalModulesAvailable) => {
  const modules = companyEntityModules.filter((item) => !item.disabled);

  return areExperimentalModulesAvailable
    ? modules
    : modules.filter(
        ({ value }) => !experimentalModules.map((module) => module.value).includes(value),
      );
};
